import styled from 'styled-components';

export const TableRow = styled.tr(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    background: theme.colors.neutral['100'],
  },
}));
